import { FormEventHandler, useState } from "react";
import { Box, Button, Container, Input, Stack, Heading } from "@chakra-ui/react";

import { Alert } from "@/components/ui/alert";
import { useAuth } from "@/hooks/useAuth";
import { PageContent, PageHeader, PageLayout } from "../page";
import { Field } from "../ui/field";

function LoginForm() {
  const [username, setUsername] = useState<string>("");
  const [usernameError, setUsernameError] = useState<string>("");

  const [password, setPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");

  const [formError, setFormError] = useState<string>();

  const { login } = useAuth();

  const handleSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    setUsernameError("");
    setPasswordError("");

    let hasError = false;

    if (!username) {
      setUsernameError("Enter your username.");
      hasError = true;
    }

    if (!password) {
      setPasswordError("Enter your password.");
      hasError = true;
    }

    if (!hasError) {
      login(username, password).catch(e => setFormError(e.message));
    }
  };

  return (
    <PageLayout>
      <PageHeader>Coracle</PageHeader>
      <PageContent>
        <Container maxW="2xl">
          <Heading p="4" size="3xl">Login</Heading>
          <Box px="4">
            <form onSubmit={handleSubmit} noValidate>
              <Stack gap="4">
                <Field label="Username" required invalid={!!usernameError} errorText={usernameError}>
                  <Input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
                </Field>
                <Field label="Password" required invalid={!!passwordError} errorText={passwordError}>
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </Field>
                {formError && <Alert status="error" title={formError} />}
                <Button type="submit" colorPalette="blue">Login</Button>
              </Stack>
            </form>
          </Box>
        </Container>
      </PageContent>
    </PageLayout>
  );
}

export default LoginForm;
